export default __webpack_public_path__ + "static/media/Preweddingshoot.9f34a41b.webp";